import getSberIdFlag from '@shared/lib/helpers/featureFlag'

let sdkLoaded = false

/**
 * динамически загружает внешний sdk sberid и резолвится, когда он готов
 */
export const addSberIDScript = () => {
  if (sdkLoaded || typeof window === 'undefined') return Promise.resolve()

  return new Promise((resolve, reject) => {
    if (window.SberidSDK) {
      sdkLoaded = true
      resolve()
      return
    }

    const isDevMode = !getSberIdFlag()
    const sberDomain = 'id.sber.ru'
    // const sberDomain = isDevMode ? 'id-ift.sber.ru' : 'id.sber.ru'

    // глобальный callback, который позволяет узнать о загрузке sdk
    window.onSberIdLoad = () => {
      sdkLoaded = true
      console.info('sberid: sdk loaded from onSberIdLoad callback')
      resolve()
    }

    /**
     * @constant scriptData
     * @description создаёт <script src="sberid-sdk.production.js"> и вешает onload,
     * аналогично реализации LINK_AUTH_EVENTS из authEventsScript
     */
    const scriptData = `
      (function (_window, _document, _script, _src) {
        var n = _document.getElementsByTagName(_script)[0];
        var s = _document.createElement(_script);
        s.type = "text/javascript";
        s.async = true;
        s.src = _src;
        s.onload = function () {
          if (typeof _window.onSberIdLoad === 'function') {
            _window.onSberIdLoad();
          }
        };
        n.parentNode.insertBefore(s, n);
      })(window, document, "script", "https://${sberDomain}/sdk/web/sberid-sdk.production.js");
    `

    const scriptTag = document.createElement('script')
    scriptTag.type = 'text/javascript'
    scriptTag.text = scriptData

    document.body.appendChild(scriptTag)
  })
}

/**
 * утилита для проверки, загружен ли sdk
 */
export const isSberIdSdkLoaded = () => sdkLoaded
